import QuotationManagementPage from "../admin/QuotationManagementPage";

// Reuse the same component as the logic is identical and role is handled inside via useAuth
export default QuotationManagementPage;
